<p-confirmDialog key="staff" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<div class="MainGrid">
					<!--Left Col-->
					<div class="Grid2Col">
						<label>Name:</label>
						<p>{{ ViewStaff?.Name }}</p>

						<label>Title:</label>
						<p>{{ ViewStaff?.StaffTitle }}</p>

						<label *ngIf="IsSU() == true">Person ID:</label>
						<p *ngIf="IsSU() == true">{{ ViewStaff?.PersonID }}</p>

						<label>Street 1:</label>
						<p>{{ ViewStaff?.Street1 }}</p>

						<label>Street 2:</label>
						<p>{{ ViewStaff?.Street2 }}</p>

						<label>City, State, Zip:</label>
						<p>{{ ViewStaff?.CityStateZip }}</p>

						<label>Date of Birth:</label>
						<p>{{ ViewStaff?.DOB }}</p>

						<label>Gender:</label>
						<p>{{ ViewStaff?.Gender }}</p>

						<label>Home Phone:</label>
						<p>{{ ViewStaff?.HomePhone }}</p>

						<ng-container *ngFor="let o of lstExtendedInfoLCol">
							<label class="ExtendedHeader">{{ o.ColHeading }}:</label>
							<p class="ExtendedValue">{{ o.ColValue }}</p>
						</ng-container>
					</div>

					<!--Right Col-->
					<div class="Grid2Col">
						<!--School Info-->
						<label>Staff ID:</label>
						<p>{{ ViewStaff?.StaffID }}</p>

						<label>{{ SSNLabel }}:</label>
						<p>{{ ViewStaff?.SSN }}</p>

						<label>Staff Type:</label>
						<p>{{ ViewStaff?.StaffType }}</p>

						<label *ngIf="IsSU() == true">Serial Number:</label>
						<p *ngIf="IsSU() == true">{{ ViewStaff?.SerialNumber }}</p>

						<label>Ethnicity:</label>
						<p>{{ ViewStaff?.EthnicityDesc }}</p>

						<label>Fax:</label>
						<p>{{ ViewStaff?.FaxNumber }}</p>

						<label>Status:</label>
						<p>{{ ViewStaff?.ActiveDesc }}</p>

						<label>Email:</label>
						<p>{{ ViewStaff?.Email }}</p>

						<label>Work Phone:</label>
						<p>{{ ViewStaff?.WorkPhone }}</p>

						<ng-container *ngFor="let o of lstExtendedInfoRCol">
							<label class="ExtendedHeader">{{ o.ColHeading }}:</label>
							<p class="ExtendedValue">{{ o.ColValue }}</p>
						</ng-container>
					</div>
				</div>

				<div class="form-group" *ngIf="processing">
					<div class="col-sm-4 col-lg-3 alert alert-info">
						<span>Processing. Please wait</span>
					</div>
				</div>

				<div class="ReminderBorder">
					<caass-staff-current-reminders-table [lstStationReminderAlert]="ViewStaff?.lstStationReminderAlert"> </caass-staff-current-reminders-table>
				</div>

				<!--Last Printed ID Card (For Digital ID)-->
				<div *ngIf="ViewStaff?.SchoolShowLastIDCard == true">
					<h4 style="text-align: center">Last ID Card Printed:</h4>

					<div class="IDCardFlex">
						<!--Left Col, Side 1-->
						<div class="IDCardBorder" *ngIf="ViewStaff?.IDCardSide1Enabled == true">
							<h4>Side 1</h4>

							<div *ngIf="ViewStaff?.IDCardSide1 != ''">
								<img class="IDCardSide" [src]="ViewStaff?.IDCardSide1" />
							</div>

							<div *ngIf="ViewStaff?.IDCardSide1 == ''">
								<label class="NoImage">N/A</label>
							</div>
						</div>

						<div></div>

						<!--Right Col, Side 2-->
						<div class="IDCardBorder" *ngIf="ViewStaff?.IDCardSide2Enabled == true">
							<h4>Side 2</h4>

							<div *ngIf="ViewStaff?.IDCardSide2 != ''">
								<img class="IDCardSide" [src]="ViewStaff?.IDCardSide2" />
							</div>

							<div *ngIf="ViewStaff?.IDCardSide2 == ''">
								<label class="NoImage">N/A</label>
							</div>
						</div>

						<div *ngIf="ViewStaff?.IDCardSide1Enabled == false && ViewStaff?.IDCardSide2Enabled == false">
							<label class="NoImage">N/A</label>
						</div>
					</div>
				</div>

				<!--Signature-->
				<div *ngIf="PersonLoading == false" class="sig-Flex">
					<div class="sig-fixed-size-div1">
						<h4>Staff Signature</h4>

						<div class="sig-fixed-size-div2">
							<img [style.display]="isSigOnFile == false ? 'none' : 'block'" width="375" height="75" [src]="SignatureData" />
							<label style="margin-top: 25px" [style.display]="isSigOnFile == true ? 'none' : 'block'">No Signature on file in CAASS</label>
						</div>
					</div>
				</div>

				<div class="hr-line-dashed"></div>

				<div style="text-align: center; margin-top: 20px; margin-left: auto; margin-right: auto">
					<button [disabled]="PersonLoading == true" (click)="onAddStaff()" class="btn btn-primary">Add Staff Member</button>
					<button [disabled]="PersonLoading == true" (click)="onEditStaff()" class="btn btn-primary">Edit Staff Member</button>
				</div>
			</div>
		</div>
	</div>
</div>
